// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__bzNLX","container":"styles_container__8AcgR","slide":"styles_slide__Yi73J"};